import { TierEnum } from '@/Domain/enum/Tier.enum';

export interface AIAssistantsData {
  current_ai_assistant: CurrentAIAssistant;
  all_ai_assistants: AIProfile[];
}

export interface CurrentAIAssistant {
  permissions: Permissions;
  scenario_id: string;
  name: string;
  fallback_name: string;
  avatar_image: string;
  review_prompt_eligible?: boolean;
}

export interface Permissions {
  home: boolean;
  ai_assistant: boolean;
  simulation: boolean;
  conversations: boolean;
  account_settings: boolean;
  subscription: boolean;
  delete_ai_agent: boolean;
  log_out: boolean;
  internal_experiments?: boolean;
}

export interface AIProfile {
  scenario_id: string;
  name: string;
  fallback_name: string;
  api_server_url: string;
  avatar_image: string;
  pricing_tier: TierEnum;
}

export enum RetrainStateEnum {
  IN_PROGRESS = 'in_progress',
  TO_BE_RETRAINED = 'to_be_retrained',
  UP_TO_DATE = 'up_to_date',
}

export enum ArticleStateEnum {
  PENDING = 'PENDING',
  SCRAPING = 'SCRAPING',
  SCRAPING_PING = 'SCRAPING_PING',
  PENDING_MULTIPLE = 'PENDING_MULTIPLE',
  META_ARTICLE_DELETED = 'META_ARTICLE_DELETED',
  DONE = 'DONE',
  ERROR = 'ERROR',
  REFRESHING = 'REFRESHING',
  REFRESH_FAILED = 'REFRESH_FAILED',
  AUTO_TAGGING = 'AUTO_TAGGING',
  AUTO_TAGGED = 'AUTO_TAGGED',
}

export interface ArticleStateChange {
  article_id: number;
  scenario_id: string;
  state: ArticleStateEnum;
  // On REFRESH_FAILED, the backend REJECT_* verdict (absent when unclassified).
  error_message?: string | null;
}
